import React from "react";
import { PureComponent } from "react";
import {
  FormGroup,
  Table,
  Input,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  CustomInput
} from "reactstrap";
// import './SearchBar.css';
import OverlayLoading from "../Commons/OverlayLoading.jsx";
import { Link } from "react-router-dom";
import moment from "moment";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
class ArticleForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  formatTime(dateString) {
    return moment(dateString).format("YYYY-MM-DD");
  }

  render() {
    return (
      <div>
        <div className="d-flex align-items-center justify-content-around mb-4">
          <button
            type="button"
            className="btn btn-default"
            style={{ flex: 1 }}
            disabled={this.props.loading}
            onClick={this.props.submitArticle}
          >
            确认
          </button>
          {/* <button
            type="button"
            className="btn btn-secondary"
            style={{ flex: 1 }}
          >
            取消
          </button> */}
        </div>

        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            作者
          </label>
          <p>{this.props.data.author}</p>
        </FormGroup>
        <FormGroup>
          <label htmlFor="exampleFormControlSelect1">選擇分類</label>
          <Input
            id="exampleFormControlSelect1"
            type="select"
            onChange={e => this.props.handleCheckBoxChange(e)}
          >
            <option
              selected={
                this.props.data.category_ids
                  ? this.props.data.category_ids.indexOf(96) !== -1
                  : false
              }
              value={96}
            >
              工作求職
            </option>
            <option
              selected={
                this.props.data.category_ids
                  ? this.props.data.category_ids.indexOf(97) !== -1
                  : false
              }
              value={97}
            >
              餐館服務
            </option>
            <option
              selected={
                this.props.data.category_ids
                  ? this.props.data.category_ids.indexOf(98) !== -1
                  : false
              }
              value={98}
            >
              家政服務
            </option>
            <option
              selected={
                this.props.data.category_ids
                  ? this.props.data.category_ids.indexOf(99) !== -1
                  : false
              }
              value={99}
            >
              維修保養
            </option>
            <option
              selected={
                this.props.data.category_ids
                  ? this.props.data.category_ids.indexOf(100) !== -1
                  : false
              }
              value={100}
            >
              商家服務
            </option>
          </Input>
        </FormGroup>
        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            標題
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.title}
            onChange={e => this.props.onTextInputChange(e, "title")}
          />
        </FormGroup>
      </div>
    );
  }
}

export default ArticleForm;
